interface IResources {
  code: string
  description: string
  id: number
  isActive: boolean
}

interface IMockedSupervisor {
  code: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
  resourceIds: number[]
  resources: IResources[]
}

export const mockedSupervisors: IMockedSupervisor[] = [
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LPF',
        description: 'XOM Pipefitter',
        isActive: true,
        id: 587,
      },
    ],
    resourceIds: [587],
    code: 'BIL.METAL TRADES FLS',
    description: 'Metal Trades Supervisor',
    isActive: true,
    id: 342,
  },
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LMA',
        description: 'XOM Machinist',
        isActive: true,
        id: 569,
      },
      {
        code: 'BI.LCMA',
        description: 'Contractor Machinist',
        isActive: true,
        id: 2024,
      },
    ],
    resourceIds: [569, 2024],
    code: 'BIL.MACHINIST FLS',
    description: 'Machinist FLS',
    isActive: true,
    id: 343,
  },
  {
    projectIds: [38, 39, 40],
    resources: [
      {
        code: 'BI.LCONCSC',
        description: 'Continuing Service Contractor',
        isActive: true,
        id: 592,
      },
      {
        code: 'BI.LCGAGNON',
        description: 'Gagnon',
        isActive: true,
        id: 2185,
      },
    ],
    resourceIds: [592, 2185],
    code: 'BIL.CONTRACTOR FLS',
    description: 'Contractor Coordinator',
    isActive: true,
    id: 344,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCIN',
        description: 'Contractor Insulator',
        isActive: true,
        id: 570,
      },
      {
        code: 'BI.LCCAS',
        description: 'Carpenter Scaffold',
        isActive: true,
        id: 572,
      },
      {
        code: 'BI.LCLA',
        description: 'Laborer General',
        isActive: true,
        id: 577,
      },
      {
        code: 'BI.LCLAA',
        description: 'Laborer Asbestos',
        isActive: true,
        id: 581,
      },
      {
        code: 'BI.LCPA',
        description: 'Contractor Painting/Blasting',
        isActive: true,
        id: 584,
      },
      {
        code: 'BI.LCLAS',
        description: 'Resource automatically created by ISTe interface',
        isActive: true,
        id: 1335,
      },
    ],
    resourceIds: [570, 572, 577, 581, 584, 1335],
    code: 'BIL.BRAND',
    description: 'BRAND',
    isActive: true,
    id: 345,
  },
  {
    projectIds: [],
    resources: [],
    resourceIds: [],
    code: 'BIL.A&I FLS',
    description: 'A&i Supervisor',
    isActive: true,
    id: 346,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCEL',
        description: 'Contractor Electrical Journeyman',
        isActive: true,
        id: 573,
      },
    ],
    resourceIds: [573],
    code: 'BIL.YECO',
    description: 'Contract Electrical Journeyman',
    isActive: true,
    id: 347,
  },
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LEL',
        description: 'XOM Electrician',
        isActive: true,
        id: 574,
      },
    ],
    resourceIds: [574],
    code: 'BIL.ELECTRICAL FLS',
    description: 'Electrical FLS',
    isActive: true,
    id: 348,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.TDL',
        description: 'LAG TIME',
        isActive: true,
        id: 575,
      },
      {
        code: 'BI.LPL',
        description: 'Mechanical Planners',
        isActive: true,
        id: 588,
      },
      {
        code: 'BI.LIS',
        description: 'XOM Inspector',
        isActive: true,
        id: 589,
      },
      {
        code: 'BI.P2CO',
        description: 'F2C PROCESS OPERATOR',
        isActive: true,
        id: 593,
      },
      {
        code: 'BI.P2BO',
        description: 'F2B PROCESS OPERATOR',
        isActive: true,
        id: 594,
      },
      {
        code: 'BI.P2AO',
        description: 'F2A PROCESS OPERATOR',
        isActive: true,
        id: 595,
      },
      {
        code: 'BI.P1AO',
        description: 'F1A PROCESS OPERATOR',
        isActive: true,
        id: 596,
      },
      {
        code: 'BI.P1BO',
        description: 'F1B PROCESS OPERATOR',
        isActive: true,
        id: 598,
      },
      {
        code: 'BI.TDLJC',
        description: 'Time Delay before Job Closure',
        isActive: true,
        id: 1906,
      },
    ],
    resourceIds: [575, 588, 589, 593, 594, 595, 596, 598, 1906],
    code: 'BIL.OTHER',
    description: 'OTHER',
    isActive: true,
    id: 349,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCPF',
        description: 'Contractor Pipefitter',
        isActive: true,
        id: 578,
      },
      {
        code: 'BI.LCBM',
        description: 'Contractor Boilermaker',
        isActive: true,
        id: 580,
      },
      {
        code: 'BI.LCOP',
        description: 'Contractor Operator',
        isActive: true,
        id: 585,
      },
    ],
    resourceIds: [578, 580, 585],
    code: 'BIL.JACOBS',
    description: 'JACOBS',
    isActive: true,
    id: 350,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCIVIL',
        description: 'COP Construction',
        isActive: true,
        id: 579,
      },
    ],
    resourceIds: [579],
    code: 'BIL.COP',
    description: 'COP Construction',
    isActive: true,
    id: 351,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCVT',
        description: 'Vacuum Truck Contractor',
        isActive: true,
        id: 582,
      },
      {
        code: 'BI.LCHJ',
        description: 'Hyjet Contractor',
        isActive: true,
        id: 597,
      },
    ],
    resourceIds: [582, 597],
    code: 'BIL.DEBUSK',
    description: 'DEBUSK',
    isActive: true,
    id: 352,
  },
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LRI',
        description: 'XOM Transportation Dept.',
        isActive: true,
        id: 583,
      },
      {
        code: 'BI.LPT',
        description: 'XOM Plant Trades',
        isActive: true,
        id: 586,
      },
    ],
    resourceIds: [583, 586],
    code: 'BIL.TRANS/PLANT TRAD',
    description: 'Trans Plant FLS',
    isActive: true,
    id: 353,
  },
  {
    projectIds: [],
    resources: [],
    resourceIds: [],
    code: 'BIL.TRANS/PLANT TRA',
    description: 'Lead Supervisor: BIL.TRANS/PLANT TRADES FLS',
    isActive: true,
    id: 354,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCIS',
        description: 'Contractor Inspection Services',
        isActive: true,
        id: 590,
      },
    ],
    resourceIds: [590],
    code: 'BIL.ACUREN',
    description: 'Acuren',
    isActive: true,
    id: 355,
  },
  {
    projectIds: [],
    resources: [
      {
        code: 'BI.LCLR',
        description: 'Plant Services Inc.',
        isActive: true,
        id: 591,
      },
    ],
    resourceIds: [591],
    code: 'BIL.PSI',
    description: 'PSI',
    isActive: true,
    id: 356,
  },
  {
    projectIds: [],
    resources: [],
    resourceIds: [],
    code: 'BIL.BAD',
    description: 'BAD',
    isActive: true,
    id: 359,
  },
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LIT',
        description: 'XOM Instrument',
        isActive: true,
        id: 571,
      },
    ],
    resourceIds: [571],
    code: 'BIL.INSTRUMENT FLS',
    description: 'Instrument FLS',
    isActive: true,
    id: 363,
  },
  {
    projectIds: [39, 40],
    resources: [
      {
        code: 'BI.LAN',
        description: 'XOM Analyzer',
        isActive: true,
        id: 576,
      },
      {
        code: 'BI.LAN.L',
        description: 'XOM Analyzer Lab',
        isActive: true,
        id: 623,
      },
    ],
    resourceIds: [576, 623],
    code: 'BIL.ANALYZER FLS',
    description: 'Analyzer FLS',
    isActive: true,
    id: 364,
  },
  {
    code: 'BIL.CONTRACTOR ELECTRICAL',
    projectIds: [],
    resources: [],
    resourceIds: [],
    description: 'Contractor Electrical',
    isActive: true,
    id: 925,
  },
]
